var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.023,
    height: 18.101,
    viewBox: "0 0 4.023 18.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "More",
    transform: "translate(71.591 -7.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-2",
    "data-name": "more",
    transform: "translate(-71.591 7.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37783",
    "data-name": "Group 37783",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37782",
    "data-name": "Group 37782"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1067",
    "data-name": "Ellipse 1067",
    cx: 2.011,
    cy: 2.011,
    r: 2.011,
    fill: "#f45e29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37785",
    "data-name": "Group 37785",
    transform: "translate(0 7.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37784",
    "data-name": "Group 37784"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1068",
    "data-name": "Ellipse 1068",
    cx: 2.011,
    cy: 2.011,
    r: 2.011,
    fill: "#f45e29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37787",
    "data-name": "Group 37787",
    transform: "translate(0 14.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37786",
    "data-name": "Group 37786"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1069",
    "data-name": "Ellipse 1069",
    cx: 2.011,
    cy: 2.011,
    r: 2.011,
    fill: "#f45e29"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.4bcfc312.svg";
export { ForwardRef as ReactComponent };